export default {
      id: "locate-white-usage",
      viewBox: "0 0 32 33",
      url: __webpack_public_path__ + "sprite.svg#locate-white",
      toString: function () {
        return this.url;
      }
    }